module.exports = __webpack_public_path__ + "media/flags/mo-3454c02c.svg";